export default defineNuxtRouteMiddleware((to, from) => {
  // skip middleware on server
  if (import.meta.server) return

  const hasLocaleChanged = from.params.locale !== to.params.locale
  const isFromQueryEmpty = Object.keys(from.query).length === 0
  const isToQueryEmpty = Object.keys(to.query).length === 0

  if (hasLocaleChanged && !isFromQueryEmpty && isToQueryEmpty) {
    const newTo = { ...to }
    newTo.query = from.query
    return newTo
  }

  return
})
